import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/auth")({
  component: AuthLayout,
});

/**
 * Auth layout provides a clean, centered container for authentication screens.
 *
 * This layout is intentionally minimal - no header, no sidebars, just a
 * centered container for auth-related content (login redirects, callbacks,
 * loading states). This prevents jarring flashes of the main app UI during
 * authentication flows.
 */
function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Outlet />
    </div>
  );
}
